import {
  Avatar,
  AvatarFallback,
  AvatarImage,
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@barfacil/barfacil-ui'
import { Store } from 'lucide-react'
import { useState } from 'react'

import {
  CompanyPicker,
  CompanyPickerResumed,
} from '@/app/panel/_components/company-picker'
import { useCompanyContext } from '@/contexts/company-context'
import { resetBodyPointerEvents } from '@/lib/utils'

type CompanyMenuContentProps = {
  onClose: () => void
}

function CompanyAvatar() {
  const { currentCompany } = useCompanyContext()

  return (
    <>
      <AvatarImage
        src=""
        width={36}
        height={36}
        alt={`Logomarca ${currentCompany?.razao_social}`}
      />

      <AvatarFallback>
        <Store className="text-gray-300" size={24} />
      </AvatarFallback>
    </>
  )
}

function CompanyMenuContent({ onClose }: CompanyMenuContentProps) {
  const { currentCompany, totalCompanies } = useCompanyContext()

  return (
    <>
      <div className="flex items-center gap-2 p-4">
        <Avatar className="size-9">
          <CompanyAvatar />
        </Avatar>

        <span className="line-clamp-1 text-sm font-bold text-gray-500">
          {currentCompany?.razao_social}
        </span>
      </div>

      {totalCompanies > 1 && (
        <>
          <div className="border border-gray-50" />

          {totalCompanies > 3 ? (
            <CompanyPicker onClose={onClose} />
          ) : (
            <CompanyPickerResumed onClose={onClose} />
          )}
        </>
      )}
    </>
  )
}

export const CompanyMenu = () => {
  const [open, setOpen] = useState(false)

  const { currentCompany } = useCompanyContext()

  function onClose() {
    setOpen(false)

    resetBodyPointerEvents()
  }

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          className="gap-3 py-6 hover:bg-gray-100/25 max-sm:px-2"
          variant="ghost"
        >
          <strong className="max-lg:hidden">
            {currentCompany?.razao_social}
          </strong>

          <Avatar className="size-9 cursor-pointer">
            <CompanyAvatar />
          </Avatar>
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        className="w-[17.5rem] p-0"
        align="end"
        side="bottom"
        sideOffset={12}
      >
        <CompanyMenuContent onClose={onClose} />
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
